

export const DetailUser = () => {

    return(
        <div className="">
            <h3> User Detail </h3>
        </div>
    )
}